module.exports = __webpack_public_path__ + "static/media/icon_68.9d20b664.svg";